import React from 'react';

import { StyledLoadingContainer, StyledAnimatedSpinContainer, StyledIcon } from './styles';

import { PlaneIcon } from '../Icons';

interface LoaderProps {
  size: 'small' | 'big';
}

export function Loader({ size }: LoaderProps) {
  return (
    <StyledLoadingContainer $size={size}>
      <StyledAnimatedSpinContainer>
        <StyledIcon>
          <PlaneIcon />
        </StyledIcon>
      </StyledAnimatedSpinContainer>
    </StyledLoadingContainer>
  );
}
